export type PostT = {
  id: number;
  title: string;
  tag: string[];
  content: string;
  date: string;
  attachments: string[];
  /**
   * Extra search terms, curated by an admin. Saved through their own endpoint,
   * because the post update endpoint requires an exact field count and would
   * erase any field absent from the payload.
   */
  keywords?: string[];
};

export enum DocumentationTab {
  Tutorials = "1",
  Notifications = "2"
}

// Documentation view enums and types
export enum DocumentationView {
  TutorialTileView = "TutorialTileView",
  TutorialVideoView = "TutorialVideoView",
  TutorialEditView = "TutorialEditView",
  NotificationPostView = "NotificationPostView",
  NotificationEditView = "NotificationEditView"
}

export interface TutorialItem {
  id: string;
  title: string;
  videoUrl: string;
  categories: Category[];
  order?: number;
  /**
   * What the video covers, in words. A title is only a few words, which is too
   * little for search to match on, so this is what makes a video findable.
   */
  description?: string;
  /**
   * Extra search terms, curated by an admin: wording customers would search for
   * that the video itself never uses. Saved through their own endpoint, so an
   * ordinary edit to the video cannot erase them.
   */
  keywords?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTutorialRequest {
  title: string;
  videoUrl: string;
  categories: string[];
  order: number;
  description?: string;
}

export interface UpdateTutorialRequest {
  title: string;
  videoUrl: string;
  categories: string[];
  order: number;
  description?: string;
}

export enum Category {
  ChartsAndDataVisualization = "Charts and Data Visualization",
  MappingAndSpatialTools = "Mapping and Spatial Tools",
  DataAndFiltering = "Data and Filtering",
  ProjectManagement = "Project Management",
  UserInterfaceAndPersonalization = "User Interface and Personalization",
  Midstream = "Midstream"
}

export const CATEGORIES = Object.values(Category);

export type NotificationItem = PostT;
